import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'role',
  data: function data() {
    return {
      roles: [],
      pageCount: 1,
      multipleSelection: [],
      loading: false,
      query: {
        Field1: '',
        Field2: '',
        PageIndex: 1,
        PageSize: 15
      }
    };
  },
  created: function created() {
    this.getData();
  },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$zybhttp.get('Balance/GetAgreementVersion', {});

              case 2:
                res = _context.sent;

                if (res.data.status == 0) {
                  data = res.data.data;

                  if (this.query.Field1 != '') {
                    data = data.filter(function (x) {
                      return x.name.indexOf(_this.query.Field1) > -1;
                    });
                  }

                  this.roles = data;
                  this.pageCount = this.roles.length || 0;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};